import { type FC, useEffect } from 'react';
import type { IconName } from '@cencosud-cencommerce/paris-uikit';
import { CouponInfo } from '@cencosud-cencommerce/paris-uikit';

interface BuyNowCouponInfoProps {
  iconName?: IconName;
  discountLabel: string;
  discountAmount: string;
  couponLabel: string;
  couponName: string;
  variant?: 'positive' | 'neutral' | 'error';
  onRemove?: () => void;
}

export const BuyNowCouponInfo: FC<BuyNowCouponInfoProps> = ({
  onRemove,
  ...props
}) => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('button') && target.closest('[data-coupon-close]')) {
        e.preventDefault();
        e.stopPropagation();
        onRemove?.();
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [onRemove]);

  return (
    <div data-coupon-close>
      <CouponInfo {...props} isFastCheckout={true} onClose={onRemove} />
    </div>
  );
};

BuyNowCouponInfo.displayName = 'BuyNowCouponInfo';
export default BuyNowCouponInfo;
